import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { IonicModule } from "@ionic/angular";
import { NgbModalModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { AdminRoutingModule } from "./admin-routing.module";
import { AdminLayoutComponent } from "./layout/admin-layout.component";
import { MaterialModule } from "../material/material-module";
import { AgmCoreModule } from "@agm/core";
import { RatingModule } from "ng-starrating";
import { AuthService } from "../auth/auth.service";
import { LoginGuard } from "../auth/loginGuard";
import {
  MatStepperModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
} from "@angular/material";
import { LayoutheaderComponent } from "./layout/layoutheader/layoutheader.component";
import { LayoutsidebarComponent } from "./layout/layoutsidebar/layoutsidebar.component";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { CKEditorModule } from "ckeditor4-angular";
import { UserService } from "../core/services/v2/user.service";
import { LayoutsubheaderComponent } from "./layout/layoutsubheader/layoutsubheader.component";
import { NgxMaskModule } from "ngx-mask";
import { SupportBugsComponent } from "./support-bugs/support-bugs.component";
import { CommonService } from "../core/services/v2/common.service";
import { PhysicianService } from "../physician/physician.service";
import { HealthOrganizationStatusComponent } from "./health-organization-status/health-organization-status.component";
import { UserImpersonateSelectionComponent } from "./user-impersonate-selection/user-impersonate-selection.component";
import { ManageTemplateFormsComponent } from "./manage-template-forms/manage-template-forms.component";
import { UserAssignComponent } from "./health-organization-status/user-assign/user-assign.component";
import { ViewModalComponent } from "./health-organization-status/view-file/view-file.component";
import { UserActivityComponent } from './user-activity/user-activity.component';
import { MarketplaceActivityComponent } from "./marketplace-activity/marketplace-activity.component";
import { NpiDataPullComponent } from './npi-data-pull/npi-data-pull.component';
import { EmployerStatusComponent } from './employer-status/employer-status.component';
import { AgencyStatusComponent } from './agency-status/agency-status.component';

@NgModule({
  imports: [
    RatingModule,
    AdminRoutingModule,
    FormsModule,
    CommonModule,
    MatStepperModule,
    HttpClientModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    AgmCoreModule,
    ReactiveFormsModule,
    SharedModule,
    CoreModule,
    CKEditorModule,
    NgxMaskModule.forRoot(),
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    PhysicianService,
    CommonService,
    UserService,
    AuthService,
    LoginGuard,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, direction: "ltr" },
    },
  ],
  declarations: [
    AdminLayoutComponent,
    LayoutheaderComponent,
    LayoutsidebarComponent,
    LayoutsubheaderComponent,
    SupportBugsComponent,
    HealthOrganizationStatusComponent,
    UserImpersonateSelectionComponent,
    ManageTemplateFormsComponent,
    UserAssignComponent,
    ViewModalComponent,
    UserActivityComponent,
    MarketplaceActivityComponent,
    NpiDataPullComponent,
    EmployerStatusComponent,
    AgencyStatusComponent,    
    NpiDataPullComponent
  ],
  entryComponents: [ViewModalComponent],
  bootstrap: [AdminLayoutComponent],
})
export class AdminModule { }
